import { CANCELLED_ORDER_FAILURE, CANCELLED_ORDER_REQUEST, CANCELLED_ORDER_SUCCESS, DELETE_ORDER_LIST_FAILURE, DELETE_ORDER_LIST_REQUEST, DELETE_ORDER_LIST_SUCCESS, GET_ORDER_LIST_FAILURE, GET_ORDER_LIST_REQUEST, GET_ORDER_LIST_SUCCESS, POST_ORDER_LIST_FAILURE, POST_ORDER_LIST_REQUEST, POST_ORDER_LIST_SUCCESS, PUT_ORDER_LIST_FAILURE, PUT_ORDER_LIST_REQUEST, PUT_ORDER_LIST_SUCCESS } from "../../../Utils/Constant";

export const getorderRequest = (payload) => {
    return {
        type: GET_ORDER_LIST_REQUEST,
        payload: payload,
    };
};

export const getorderSuccess = (data) => {
    return {
        type: GET_ORDER_LIST_SUCCESS,
        payload: data,
    };
};

export const getorderFailure = (error) => {
    return {
        type: GET_ORDER_LIST_FAILURE,
        payload: error,
    };
};

//add room
export const addorderRequest = (payload) => {
    return {
        type: POST_ORDER_LIST_REQUEST,
        payload: payload,
    };
};

export const addorderSuccess = (data) => {
    return {
        type: POST_ORDER_LIST_SUCCESS,
        payload: data,
    };
};

export const addorderFailure = (error) => {
    return {
        type: POST_ORDER_LIST_FAILURE,
        payload: error,
    };
};

//deleteroom
export const deleteorderRequest = (payload) => {
    return {
        type: DELETE_ORDER_LIST_REQUEST,
        payload: payload,
    };
};

export const deleteorderSuccess = (data) => {
    return {
        type: DELETE_ORDER_LIST_SUCCESS,
        payload: data,
    };
};

export const deleteorderFailure = (error) => {
    return {
        type: DELETE_ORDER_LIST_FAILURE,
        payload: error,
    };
};

//update by id
export const updateorderRequest = (payload) => {
    return {
        type: PUT_ORDER_LIST_REQUEST,
        payload: payload,
    };
};

export const updateorderSuccess = (data) => {
    return {
        type: PUT_ORDER_LIST_SUCCESS,
        payload: data,
    };
};

export const updateorderFailure = (error) => {
    return {
        type: PUT_ORDER_LIST_FAILURE,
        payload: error,
    };
};


//update by idcancelled
export const cancelledorderRequest = (payload) => {
    return {
        type: CANCELLED_ORDER_REQUEST,
        payload: payload,
    };
};

export const cancelledorderSuccess = (data) => {
    return {
        type: CANCELLED_ORDER_SUCCESS,
        payload: data,
    };
};

export const cancelledorderFailure = (error) => {
    return {
        type: CANCELLED_ORDER_FAILURE,
        payload: error,
    };
};
